import { Toggle } from "components/forms/Toggle"
import { NsKey } from "enums/NsKey"
import { FC } from "react"
import { useTranslation } from "react-i18next"
import { useMainBorrowerPricing } from "../../contexts/main-borrower-pricing/MainBorrowerPricingContext"
import { PricingSideMenuSkeleton } from "features/subscription-process/pricing-process/components/loading/PricingSideMenuSkeleton"
import { BorrowerCommissionCard } from "./BorrowerCommissionCard"
import { BorrowerFunnelFilters } from "./BorrowerFunnelFilters"

export const BorrowerPricingSideMenu: FC = () => {
  const { toggleIsProMode, state } = useMainBorrowerPricing();
  const { isProMode, isLoading, filters } = state
  const { t } = useTranslation(NsKey.Pricing)

  // Afficher le skeleton si on charge OU si les filtres ne sont pas encore disponibles
  if (isLoading || filters.length === 0) {
    return <PricingSideMenuSkeleton showProMode={isProMode} />
  }

  return <div className="flex-none relative w-full xl:w-[250px] 2xl:w-[320px] flex flex-col gap-6">
    <div className={`p-4 bg-white rounded-xl border shadow`}>
      <div className="flex items-center justify-between gap-3">
        <p>{t("PRICING.SIDE_MENU.PRO_MODE")}</p>
        <div className="flex items-center">
          <Toggle onChange={toggleIsProMode} value={isProMode} />
        </div>
      </div>
    </div>
    {isProMode && <BorrowerCommissionCard />}
    <BorrowerFunnelFilters />
  </div>
}
